import { render, staticRenderFns } from "./editEmail.vue?vue&type=template&id=687fba1b&scoped=true&"
import script from "./editEmail.vue?vue&type=script&lang=js&"
export * from "./editEmail.vue?vue&type=script&lang=js&"
import style0 from "./editEmail.vue?vue&type=style&index=0&id=687fba1b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fba1b",
  null
  
)

export default component.exports